import React, { Component } from 'react'
import ScrollToTop from '../../../../components/ScrollToTop'
import MenuSider from '../../../../components/MenuSider'
import { connect } from 'react-redux'
import IntlMessages from '../../../../util/IntlMessages';
import { Form, Button, Icon, message, Upload, Modal, Spin, Checkbox } from 'antd';
import './Checklist.scss'
import { Link } from 'react-router-dom'
import Job from './Job/index'
import Category from './Category/index'
import axios from 'axios'
import { Odata_Url, Odata_Filestream_Url, Constants } from '../../../../Constants/Constants'


const warning_job = () => {
    message.warning('Please select job');
};
const warning_category = () => {
    message.warning('Please select category');
};

var initialjob = [];
var initialcate = [];

const type_category_icon = ['', 'like', 'dislike', 'minus-circle'];
const type_category = ['Observe', 'Safe', 'Unsafe', 'Observed'];
const type_sub_cate = ['NA', 'Safe', 'Unsafe'];

function beforeUpload(file) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJPG) {
        message.error('You can only upload JPG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
        message.error('Image must smaller than 5MB!');
    }
    return isJPG && isLt2M;
}

class Checklist extends Component {
    constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleClick2 = this.handleClick2.bind(this);
        this.onRemoveCategory = this.onRemoveCategory.bind(this);
        this.selected_office = this.selected_office.bind(this);
        this.handleOutsideClick3 = this.handleOutsideClick3.bind(this);
        this.clear_job = this.clear_job.bind(this);
        this.select_job = this.select_job.bind(this);
        this.onchange_cat_status = this.onchange_cat_status.bind(this)
        this.Nextstep = this.Nextstep.bind(this)

        this.state = {
            category: [],
            category_forward: [],
            previewVisible: false,
            previewImage: '',
            popupVisible: false,
            popupVisible2: false,
            popupVisible3: false,
            job: [],
            cat_id: [],
            initial_job: [],
            show_cate: false,
            type_of_category: [],
            fileList: [],
            selected_category: "",
            onLoading: false,
            jobtype: {},
            mode: 'create'
        }
    }

    componentWillMount() {

        if (this.props.location.state === undefined) {
            window.localStorage.removeItem("select_job")
            window.localStorage.removeItem("type_of_category")
            window.localStorage.removeItem("Select_Category")
            window.localStorage.removeItem("Detail_Category")
        }

        this.initJobTypeCate();

    }

    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng)
            this.setState({ isEng: isEng })
    }

    initJobTypeCate() {
        this.setState({ onLoading: true })
        let mode = (this.props.location.state || {}).mode || 'create'
        this.setState({ mode: mode })
        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })
        //var cate = JSON.parse(window.localStorage.getItem('Category'))
        //var job2 = JSON.parse(window.localStorage.getItem('Jobtype'))
        var select_cat = JSON.parse(window.localStorage.getItem('Select_Category'))
        var detail_cat = JSON.parse(window.localStorage.getItem('Detail_Category'))
        var se_job = JSON.parse(window.localStorage.getItem('select_job'))
        var type_cate1 = JSON.parse(window.localStorage.getItem('type_of_category'))

        this.getJobType().then(job2 => {
            Promise.all([this.getCategory().then(cate => {
                var count_job = false
                var type_cate = []
                var jobtype = {}
                if (se_job !== null) {
                    initialjob = se_job
                    var index = -1;
                    for (var i = 0; i < se_job.length; i++) {
                        if (se_job[i].factory === 1) {
                            count_job = true
                            this.setState({
                                selected_category: "factory"
                            })
                            index = i;
                            break;
                        }
                        if (se_job[i].office === 1) {
                            count_job = true
                            this.setState({
                                selected_category: "office"
                            })
                            index = i;
                            break;
                        }
                    }

                    jobtype = job2[index];

                    if (count_job) {
                        this.setState({
                            show_cate: true
                        })
                    }
                } else {
                    job2.map((l, i) => {
                        initialjob[i] = { factory: 0, office: 0 }
                        return true
                    })
                    return true
                }

                var initcate = [];

                this.getJobtypeCategory().then(jobcat => {
                    var cat = jobcat === undefined ? undefined : jobtype === undefined ? [] : jobcat.filter(x => x.JobTypeId === jobtype.PKJobTypeID && x.SubCatId === null);
                    var jcat = jobcat === undefined ? undefined : jobcat.filter(x => x.JobTypeId == jobtype.PKJobTypeID && x.SubCatId !== null);

                    cat.map((l, i) => {
                        var temp_cate = cate.find(x => x.PKCategoryID === l.CatId)
                        temp_cate.IsRequired = jobcat.filter(x => x.IsRequired && x.CatId === l.CatId && x.JobTypeId === jobtype.PKJobTypeID).length > 0
                        if (temp_cate)
                            initcate.push(temp_cate);
                        return true
                    })

                    if (type_cate1 !== null) {
                        type_cate = type_cate1
                        type_cate.map(l => {
                            let index = initcate.findIndex(x => x.PKCategoryID === l.cat_id)
                            initcate[index].Checked = initcate[index].IsRequired || l.icon.indexOf('like') > -1 || l.icon.indexOf('-') > -1
                        })
                    } else {
                        for (let i = 0; i < initcate.length; i++) {
                            type_cate[i] = { cat_id: initcate[i].PKCategoryID, type: type_category[0], icon: type_category_icon[0] }
                            initcate[i].Checked = initcate[i].IsRequired
                        }
                    }

                    if (select_cat === null) {
                        jcat.map((l, i) => {
                            initialcate[i] = { cate_id: l.CatId, subcate_id: l.SubCatId, status: 0, text: type_sub_cate[0] }
                            return null
                        })
                        window.localStorage.setItem('Select_Category', JSON.stringify(initialcate));
                    }

                    var initial_detail_cat = []
                    if (detail_cat === null) {
                        cate.map((l, i) => {
                            initial_detail_cat[i] = { category_ID: l.PKCategoryID, detail: null, rule: false, root_cause: null, near_miss: false }
                            return null
                        })
                        window.localStorage.setItem('Detail_Category', JSON.stringify(initial_detail_cat))
                    }

                    this.setState({
                        category: initcate,
                        jobtype: jobtype,
                        job: job2,
                        initial_job: initialjob,
                        type_of_category: type_cate
                    })
                    window.localStorage.setItem('type_of_category', JSON.stringify(type_cate));
                    window.localStorage.setItem('Category', JSON.stringify(initcate));
                })
            }), this.initImage()]).then(() => {
                this.setState({ onLoading: false });
            })
        })
    }

    async getJobType() {
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let job_res = await axios.get(
                    Odata_Url + 'OJobType?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then((response) => {
                    const data = [];
                    response.data.value.forEach(function (element) {
                        data.push(element);
                    });
                    window.localStorage.setItem('Jobtype', JSON.stringify(data));
                    return data;
                }, (error) => { console.log(error) });
                return job_res;
            }, (error) => {
                console.log(error);
                if (401 === error.response.status) {
                    window.location.href = "auth";
                }
                return true
            });
        return res;
    }

    initImage() {
        var state = JSON.parse(window.localStorage.getItem('state'))
        var basic_info = state.set_basic_info
        let ObtranID = basic_info.observation_id
        var Token
        this.setImage()
        let files = this.state.fileList
        return axios.get(Constants.BASE_URL + 'auth/token').then(response => {
            Token = response.data
            return axios.get(Odata_Url + 'OAttachment?$filter=IsActived eq true and ObtranID eq ' + ObtranID,
                { headers: { "Authorization": "Bearer " + Token } }).then(res => {
                    let image_guid = []
                    res.data.value.forEach(function (element) {
                        if (files.filter(x => x.uid === element.Guid).length === 0)
                            image_guid.push(element.Guid)
                    });

                    let fileList = files
                    let wait_map = image_guid.map(l => {
                        return axios.get(Constants.BASE_URL + 'api/Attachment/GetImageByGuid?guid=' + l).then((response) => {
                            if (response.data) {
                                fileList.push({
                                    uid: response.data.guid,
                                    name: response.data.filename,
                                    status: 'done',
                                    url: 'data:image/jpeg;base64,' + response.data.data
                                });
                            }
                        })
                    })
                    return Promise.all(wait_map).then(() => {
                        if (image_guid.length > 0 && fileList.length === 0)
                            message.error('Can\'t get image(s), Please contact It one.');
                        this.setState({
                            fileList: fileList
                        })
                    })
                })
        }).catch(err => {
            if (401 === err.response.status) {
                window.location.href = "auth";
            }
        });
    }

    async getCategory() {
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let cat_res = await axios.get(
                    Odata_Url + 'OCategoryMD?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then((response) => {
                    const data = [];
                    response.data.value.forEach(function (element) {
                        data.push(element);
                    });
                    window.localStorage.setItem('Category', JSON.stringify(data));
                    return data;
                },
                    (error) => {
                        console.log(error);
                    });
                return cat_res;
            },
                (error) => {
                    console.log(error);
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                });
        return res;
    }

    async getSubcategory() {
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let scat_res = await axios.get(
                    Odata_Url + 'OSub_Category?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        const data = [];
                        response.data.value.forEach(function (element) {
                            data.push(element);
                        });
                        window.localStorage.setItem('Sub_Category', JSON.stringify(data));
                        return data;
                    },
                        (error) => {
                            console.log(error);
                            if (401 === error.response.status) {
                                window.location.href = "auth";
                            }
                        });
                return scat_res;
            },
                (error) => {
                    console.log(error);
                });
        return res;
    }

    async getJobtypeCategory() {

        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let cat_res = await axios.get(
                    Odata_Url + 'OJobType_Category?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        const data = [];
                        response.data.value.forEach(function (element) {
                            data.push(element);
                        });
                        return data;
                    },
                        (error) => {
                            console.log(error);
                        });
                return cat_res;
            },
                (error) => {
                    console.log(error);
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                });
        return res;
    }

    setImage() {
        // console.log(this.props.set_checklist.upload)
        if (this.props.set_checklist.upload !== undefined && this.props.set_checklist.upload !== null) {
            this.setState({
                fileList: this.props.set_checklist.upload
            })
        }

    }

    handleClick() {
        if (!this.state.popupVisible) {
            // attach/remove event handler
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState(prevState => ({
            popupVisible: !prevState.popupVisible,
        }));
    }

    handleCategoryClick(CatId) {
        var select_cat = JSON.parse(window.localStorage.getItem('Select_Category'))
        var detail_cat = JSON.parse(window.localStorage.getItem('Detail_Category'))
        let category = this.state.category
        category.map(x => x.Checked = x.PKCategoryID === CatId ? !x.Checked : x.Checked)
        select_cat.map(x => {
            if (x.cate_id === CatId) {
                x.status = 0
                x.text = type_sub_cate[0]
            }
        })
        detail_cat.map(x => {
            if (x.category_ID === CatId) {
                x.detail = ''
                x.rule = false
            }
        })
        let type_of_category = this.state.type_of_category
        type_of_category.map(l => {
            if (l.cat_id === CatId) {
                l.icon = type_category_icon[0]
                l.type = type_category[0]
            }
        })

        window.localStorage.setItem('Select_Category', JSON.stringify(select_cat))
        this.setState({
            category: category
        })

        var type_cate = this.state.type_of_category
        let initialcate = select_cat
        let cat_index = type_cate.findIndex(x => x.cat_id === CatId)
        type_cate[cat_index].type = type_category[0]
        type_cate[cat_index].icon = type_category_icon[0]

        var count_safe_unsafe = false
        for (var i = 0; i < initialcate.length; i++) {
            if (initialcate[i].text === "Unsafe") {
                count_safe_unsafe = true
                break;
            }
        }
        if (count_safe_unsafe) {
            window.localStorage.setItem("status_of_observed", 'unsafe');
        } else {
            window.localStorage.setItem("status_of_observed", 'safe');
        }
        this.setState({
            type_of_category: type_cate
        })
        window.localStorage.setItem("type_of_category", JSON.stringify(type_cate))

    }

    onRemoveCategory(CatId, initialcate) {
        let category = this.state.category
        category.map(x => x.Checked = x.PKCategoryID === CatId ? !x.Checked : x.Checked)
        this.setState({
            category: category,
            category_forward: category.filter(x => x.Checked)
        })
        if (category.filter(x => x.Checked).length === 0) {
            if (this.state.selected_category === "office") {
                this.setState(prevState => ({
                    popupVisible3: !prevState.popupVisible3,
                }));
                return
            }
            this.setState(prevState => ({
                popupVisible2: !prevState.popupVisible2,
            }));
        }

        var type_cate = this.state.type_of_category
        let cat_index = type_cate.findIndex(x => x.cat_id === CatId)
        type_cate[cat_index].type = type_category[0]
        type_cate[cat_index].icon = type_category_icon[0]

        var count_safe_unsafe = false
        for (var i = 0; i < initialcate.length; i++) {
            if (initialcate[i].text === "Unsafe") {
                count_safe_unsafe = true
                break;
            }
        }
        if (count_safe_unsafe) {
            window.localStorage.setItem("status_of_observed", 'unsafe');
        } else {
            window.localStorage.setItem("status_of_observed", 'safe');
        }
        this.setState({
            type_of_category: type_cate
        })
        window.localStorage.setItem("type_of_category", JSON.stringify(type_cate))

    }

    handleOutsideClick(e) {
        // ignore clicks on the component itself
        if (this.node === null) {
            return;
        }
        if (this.node.contains(e.target)) {
            return;
        }

        this.handleClick();
    }

    handleClick2() {
        let category = this.state.category.filter(x => x.Checked)
        if (this.state.selected_category === "office") {
            this.setState(prevState => ({
                category_forward: category,
                popupVisible3: !prevState.popupVisible3,
            }));
            return
        }
        this.setState(prevState => ({
            category_forward: category,
            popupVisible2: !prevState.popupVisible2,
        }));
    }

    selected_office(id) {
        if (!this.state.popupVisible3) {
            // attach/remove event handler
            document.addEventListener('click', this.handleOutsideClick3, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick3, false);
        }

        this.setState(prevState => ({
            popupVisible3: !prevState.popupVisible3,
        }));
        this.setState({
            cat_id: id
        })
    }

    handleOutsideClick3(e) {
        // ignore clicks on the component itself
        if (this.node.contains(e.target)) {
            return;
        }

        this.selected_office();
    }
    select_job(job, selecte_category) {
        // console.log(selecte_category)

        initialjob = job
        this.setState({
            initial_job: initialjob,
            selected_category: selecte_category
        })
        if (selecte_category === 'factory' || selecte_category === 'office') {
            this.setState({
                show_cate: true
            })
        } else {
            this.setState({
                show_cate: false
            })
        }

        this.initJobTypeCate();


        // console.log("success")
        // console.log(initialjob)
    }
    clear_job() {
        for (var i = 0; i < initialjob.length; i++) {
            initialjob[i].job = 0
        }
        // console.log(initialjob)
        this.setState({
            initial_job: initialjob
        })
        window.localStorage.setItem('select_job', JSON.stringify(initialjob))
    }
    onchange_cat_status(cat_id, initialcate) {
        var type_cate = this.state.type_of_category

        let cat_index = type_cate.findIndex(x => x.cat_id === cat_id)

        var count_safe = 0
        var count_unsafe = 0
        for (var i = 0; i < initialcate.length; i++) {
            if (initialcate[i].cate_id === cat_id) {
                switch (initialcate[i].status) {
                    case 0:
                        continue;
                    case 1: count_safe++
                        continue;
                    case 2: count_unsafe++
                        break;
                    default:
                        continue;
                }
            }
        }
        if (count_unsafe !== 0) {
            type_cate[cat_index].type = type_category[2]
            type_cate[cat_index].icon = type_category_icon[2]
        } else {
            if (count_safe !== 0) {
                type_cate[cat_index].type = type_category[1]
                type_cate[cat_index].icon = type_category_icon[1]
            } else {
                type_cate[cat_index].type = type_category[3]
                type_cate[cat_index].icon = type_category_icon[3]
            }
        }
        var count_safe_unsafe = false
        for (var i = 0; i < initialcate.length; i++) {
            if (initialcate[i].text === "Unsafe") {
                count_safe_unsafe = true
                break;
            }
        }
        if (count_safe_unsafe) {
            window.localStorage.setItem("status_of_observed", 'unsafe');
        } else {
            window.localStorage.setItem("status_of_observed", 'safe');
        }
        this.setState({
            type_of_category: type_cate
        })
        window.localStorage.setItem("type_of_category", JSON.stringify(type_cate))
    }
    Nextstep() {
        const { type_of_category, fileList, category } = this.state
        // var check_type_of_category = false
        // for (var i = 0; i < type_of_category.length; i++) {
        //     if (type_of_category[i].type !== "Observe") {
        //         check_type_of_category = true
        //         break;
        //     }
        // }


        let isPass = category.filter(x => { if (x.IsRequired) return x.Checked }).length === category.filter(x => x.IsRequired).length

        if (isPass) {
            this.props.SET_IMAGE_CATEGORY(fileList)
            this.props.history.push({
                pathname: '/newobservation/category',
                state: {
                    category: this.state.category.filter(x => x.Checked),
                    jobtype: this.state.jobtype,
                    mode: this.state.mode
                },
                cat_status: this.onchange_cat_status
            })
        } else {
            warning_category()
        }
    }
    handleChange = ({ fileList }) => {
        this.setState({
            fileList: fileList
        })
    }
    handleCancel = () => this.setState({ previewVisible: false })

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }
    render() {
        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
            </div>
        );

        const view = this.state.mode === 'view'

        // console.log(initialjob)
        var category_forward = this.state.category_forward
        const { initial_job, type_of_category, previewVisible, previewImage, fileList } = this.state

        return (
            <div >
                <Spin spinning={this.state.onLoading} size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} tip="Loading...">
                    <ScrollToTop />
                    <MenuSider title={<IntlMessages id="checklist.title" />} >
                        <div className='checklist'>
                            <div style={{ width: "80%", margin: "13px 5% 0 5%" }} >
                                <div style={{ width: "100%", fontSize: "13px" }}>
                                    {
                                        this.state.show_cate && (
                                            <div style={{ width: "80%", display: "inline-block", color: "black" }} key="Job">
                                                <IntlMessages id="Checklist.job_observed" />
                                            </div>
                                        )
                                    }
                                    {
                                        !this.state.show_cate && (
                                            <div style={{ width: "110%", display: "inline-block", color: "black", textAlign: "center" }} key="Job">
                                                <IntlMessages id="Checklist.job_observed_2" />
                                            </div>
                                        )
                                    }
                                    <div style={{ width: "20%", display: "inline-block", padding: "10px" }} >
                                        {
                                            this.state.show_cate && !view ? (
                                                <div onClick={this.handleClick} className="icon-edit-job">
                                                    <div>Edit</div>
                                                </div>
                                            ) : null
                                        }
                                    </div>


                                    {this.state.popupVisible && (

                                        <div id="popup-job" className="popup-job" ref={node => { this.node = node; }}>
                                            <div className="popup-job-content job-animate">
                                                <div className="popup-job-topic">
                                                    <Job onclose={this.handleClick} selectjob={this.select_job} selected_category={this.state.selected_category} />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {
                                        initial_job.map((l, i) => {
                                            if (l.factory === 1 || l.office === 1) {
                                                return (
                                                    <div>
                                                        {
                                                            this.state.job.map((k, j) => {
                                                                if (j === i) {
                                                                    return (
                                                                        <>
                                                                            <div className="image-job" key={'job' + i}>
                                                                                <img src={'/images/' + k.Image_name} key={'image_job' + i} title={k.Short_detail} />
                                                                            </div>
                                                                            <label>{this.state.isEng ? k.Short_detail_EN : k.Short_detail}</label>
                                                                        </>
                                                                    )
                                                                }
                                                                return null
                                                            })
                                                        }
                                                    </div>
                                                )
                                            }
                                        })
                                    }
                                </div>
                            </div>

                            {
                                this.state.show_cate && (this.state.selected_category === "factory") && (
                                    <div>
                                        <div style={{ width: "100%", marginTop: "10px" }}>
                                            {
                                                this.state.category.map((l, i) => {
                                                    if (l.Type_Category === 'factory') {
                                                        let icon_index = type_of_category.findIndex(x => x.cat_id === l.PKCategoryID)
                                                        return (
                                                            <div onClick={() => view || l.IsRequired ? null : this.handleCategoryClick(l.PKCategoryID)} style={{ width: "100%", borderBottom: "1px solid #EEE", height: "50px", marginBottom: "10px", padding: "5px", cursor: "pointer" }} key={'category_factory' + i}>
                                                                <img src={"/images/" + l.Image_name} className="image-category" style={{ borderRadius: "30%", filter: "grayscale(100%)", objectFit: "contain" }} />
                                                                <div className='txt-category' onClick={() => view || l.IsRequired ? null : this.handleCategoryClick(l.PKCategoryID)}> <Checkbox onClick={() => view || l.IsRequired ? null : this.handleCategoryClick(l.PKCategoryID)} checked={l.Checked}>{this.state.isEng ? l.Category_Name_EN : l.Category_Name} {l.IsRequired ? (<label className='required' title='required'>*</label>) : null} </Checkbox>  </div>
                                                                <div className='ico-category'> <Icon type={type_of_category[icon_index].icon} style={{ fontSize: "17px" }} /> </div>
                                                            </div>
                                                        )
                                                    }
                                                    return null
                                                })
                                            }
                                            {
                                                this.state.popupVisible2 && (
                                                    <div id="popup-category" className="popup-category" ref="job" ref={node => { this.node = node; }}>
                                                        <div className="popup-job-content job-animate">
                                                            <div className="popup-job-topic" >
                                                                <Category onclose={this.handleClick2} onRemoveCategory={this.onRemoveCategory} job_id={this.state.jobtype} category={category_forward} mode={this.state.mode} cat_status={this.onchange_cat_status} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>

                                    </div>
                                )
                            }
                            {
                                this.state.show_cate && (this.state.selected_category === "office") && (
                                    <div>
                                        <div style={{ width: "100%", marginTop: "10px" }}>
                                            {
                                                this.state.category.map((l, i) => {
                                                    // console.log(l.PKCategoryID)
                                                    if (l.Type_Category === 'office') {
                                                        let icon_index = type_of_category.findIndex(x => x.cat_id === l.PKCategoryID)
                                                        return (
                                                            <div onClick={() => view || l.IsRequired ? null : this.handleCategoryClick(l.PKCategoryID)} style={{ width: "100%", borderBottom: "1px solid #EEE", height: "50px", marginBottom: "10px", padding: "5px" }} key={'category_office' + i}>
                                                                <img src={"/images/" + l.Image_name} className="image-category" style={{ borderRadius: "30%", filter: "grayscale(100%)", objectFit: "contain" }} />
                                                                <div className='txt-category' onClick={() => view || l.IsRequired ? null : this.handleCategoryClick(l.PKCategoryID)}> <Checkbox onClick={() => view || l.IsRequired ? null : this.handleCategoryClick(l.PKCategoryID)} checked={l.Checked}>{this.state.isEng ? l.Category_Name_EN : l.Category_Name} {l.IsRequired ? (<label className='required' title='required'>*</label>) : null} </Checkbox>  </div>
                                                                <div className='ico-category'> <Icon type={type_of_category[icon_index].icon} style={{ fontSize: "17px" }} /> </div>
                                                            </div>
                                                        )
                                                    }
                                                    return null
                                                })
                                            }
                                            {
                                                this.state.popupVisible3 && (
                                                    <div id="popup-category" className="popup-category" ref="job" ref={node => { this.node = node; }}>
                                                        <div className="popup-job-content job-animate">
                                                            <div className="popup-job-topic" >
                                                                <Category onclose={this.handleClick2} onRemoveCategory={this.onRemoveCategory} job_id={this.state.jobtype} category={category_forward} mode={this.state.mode} cat_status={this.onchange_cat_status} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                )
                            }

                            {/* {
                                this.state.show_cate && (
                                    <div style={{ width: 125, margin: "0px 0px 10px 5%" }} >
                                        <Button onClick={this.handleClick2} disabled={this.state.category.filter(x => x.Checked).length === 0} type='primary' icon='schedule' size='large' block>Choose</Button>
                                    </div>
                                )
                            } */}

                            {
                                this.state.show_cate ? (
                                    <div style={{ padding: "0 5%" }}>
                                        <Upload
                                            listType="picture-card"
                                            fileList={fileList}
                                            onPreview={this.handlePreview}
                                            onChange={this.handleChange}
                                            className="picture-card"
                                            beforeUpload={beforeUpload}
                                            disabled={view}
                                        >
                                            {fileList.length >= 4 ? null : uploadButton}
                                        </Upload>
                                    </div>
                                ) : null
                            }

                            <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                                <img alt="example" style={{ width: '100%' }} src={previewImage} />
                            </Modal>
                            {/* selected job */}
                            {
                                this.state.show_cate && (
                                    <div className="footer" style={{ textAlign: "center", position: "fixed", height: "48px" }} >
                                        <Link to={{ pathname: "/newobservation_basic_info", state: { back: "Checklist", mode: this.state.mode } }} style={{ color: "white" }}>
                                            <Button style={{ width: "50%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                                <Icon type="caret-left" style={{ position: "relative", right: "-4px" }} />
                                                <IntlMessages id='Back' />
                                            </Button>
                                        </Link>
                                        {/* <Link to="/newobservation_action" style={{ color: "white" }}> */}
                                        <Button onClick={this.Nextstep} style={{ width: "50%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                        <IntlMessages id='Next' /> <Icon type="caret-right" style={{ position: "relative", left: "-4px" }} />
                                        </Button>
                                        {/* </Link> */}
                                    </div>
                                )
                            }

                            {/* Not select job */}
                            {
                                !this.state.show_cate && (
                                    <div onClick={this.handleClick} style={{ width: "150px", height: "80px", border: "1px solid rgb(1 135 124)", backgroundColor: "rgb(0,152,139)", borderRadius: "10px", display: "block", marginLeft: "auto", marginRight: "auto", marginTop: "20px", cursor: "pointer" }}>
                                        {/* <Icon type="check-square" style={{ fontSize: "50px", color: "white", position: "relative", top: "25%", left: "25%" }} /> */}
                                        <div style={{ fontSize: "22px", color: "white", position: "relative", top: "28%", textAlign: "center" }}>
                                            Select
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </MenuSider>
                </Spin>
                {
                    !this.state.show_cate && (
                        <div style={{ width: "100%", textAlign: "center", position: "fixed", bottom: "0", height: "48px" }} >
                            <Link to={{
                                pathname: "/newobservation_basic_info",
                                state: { back: "Checklist", mode: this.state.mode }
                            }}>
                                <Button style={{ width: "50%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124) ", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                    <Icon type="caret-left" style={{ position: "relative", top: "1px", right: "-4px" }} />
                                    <IntlMessages id='Back' />
                                </Button>
                            </Link>
                            <Button onClick={warning_job} style={{ width: "50%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                            <IntlMessages id='Next' /> <Icon type="caret-right" style={{ position: "relative", top: "1px", left: "-4px" }} />
                            </Button>
                        </div>
                    )
                }
            </div>
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
        set_checklist: state.set_checklist,
    }
}
const mapDispatchProps = (dispatch) => {
    return {
        SET_IMAGE_CATEGORY: (value) => {
            dispatch({
                type: "SET_IMAGE_CATEGORY",
                upload: value
            })
        },
    }
}

const Newobservation_Checklist = Form.create()(Checklist);

export default connect(mapStatetoProps, mapDispatchProps)(Newobservation_Checklist)